import { render } from "./doctorsidebar.vue?vue&type=template&id=d622cffe&scoped=true"
import script from "./doctorsidebar.vue?vue&type=script&lang=js"
export * from "./doctorsidebar.vue?vue&type=script&lang=js"

import "./doctorsidebar.vue?vue&type=style&index=0&id=d622cffe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d622cffe"]])

export default __exports__